// extracted by mini-css-extract-plugin
module.exports = {"root":"Box_root__ibH-z"};